import { PageContext } from './index'

const page: PageContext = {
  name: 'community',
  url: '/community',
  breadcrumbs: [
    {
      phrase: ['Common', 'breadcrumb.homepage.text'],
      url: '/'
    },
    {
      phrase: ['Forum', 'nav.title.community.overview'],
      url: './'
    }
  ]
}

export default page
